import { Box, Button, ButtonGroup, Heading, Modal, Paragraph, TextButton } from '@zillow/constellation-10';

interface CancelModalInterface {
  isOpen: boolean;
  toggleIsOpen: (...args: any) => any;
  goToDashboard: (...args: any) => any;
}

const CancelModal = (props: CancelModalInterface) => (
  <Modal
    trigger={null}
    size="sm"
    open={props.isOpen}
    onOpenChange={(isOpen) => {
      if (!isOpen) {
        props.toggleIsOpen();
      }
    }}
    header={
      <Box css={{ padding: '16px 48px 16px 16px !important' }}>
        <Heading level={2} textStyle="heading-xs">
          Discard your changes?
        </Heading>
      </Box>
    }
    body={
      <Box css={{ padding: 'token(spacing.sm) !important' }}>
        <Paragraph>We&apos;ll continue using your current payment method for all future payments.</Paragraph>
      </Box>
    }
    footer={
      <Box css={{ padding: 'token(spacing.sm) !important' }}>
        <ButtonGroup aria-label="action-buttons" role="group">
          <TextButton onClick={props.toggleIsOpen}>Back</TextButton>
          <Button emphasis="filled" onClick={props.goToDashboard}>
            Discard changes
          </Button>
        </ButtonGroup>
      </Box>
    }
  />
);

export default CancelModal;
